import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { flashMessage as flash } from "./../../../utils/flash/index";
import workflowService from "./workflowService";
import { current } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  isSuccess: false,
  isFetching: false,
  isUpdated: false,
  isError: false,
  workflowData: null,
  singleWorkflow: null,
  unpaginated_workflow: null,
};

const workflowSlice = createSlice({
  initialState,
  name: "workflow",
  reducers: {
    resetWorkflow: (state) => initialState,
    resetWorkflowStatus: (state) => {
      state.isError = false;
      state.isSuccess = false;
      state.isLoading = false;
      state.isUpdated = false;
      state.isFetching = false;
    },
    resetSingleWorkflow: (state) => {
      state.singleWorkflow = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitWorkflow.pending, (state) => {
        state.isLoading = true;
        flash("loading", "Submitting...");
      })
      .addCase(submitWorkflow.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (!payload.errors) {
          state.isSuccess = true;
          flash("success", `${payload.message}`);
        } else if (typeof payload.errors == "string") {
          flash("error", payload.errors);
        } else {
          let key = Object.keys(payload.errors)[0];
          let message = payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(submitWorkflow.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(getAllWorkflow.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllWorkflow.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.workflowData = payload;
        if (!payload.errors) {
          state.isLoading = false;
          state.unpaginated_workflow = payload.get_work_flow
        } else if (typeof payload.errors == "string") {
          flash("error", payload.errors);
        } else {
          let key = Object.keys(payload.errors)[0];
          let message = payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(getAllWorkflow.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(getSingleWorkflow.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getSingleWorkflow.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.singleWorkflow = payload;
        if (!payload.errors) {
          state.isLoading = false;
        } else if (typeof payload.errors == "string") {
          flash("error", payload.errors);
        } else {
          let key = Object.keys(payload.errors)[0];
          let message = payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(getSingleWorkflow.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(updateSingleWorkflow.pending, (state) => {
        state.isLoading = true;
        flash("loading", "Updating workflow...");
      })
      .addCase(updateSingleWorkflow.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (!payload.errors) {
          state.isLoading = false;
          state.isUpdated = true;
          flash("success", payload.message);
        } else if (typeof payload.errors == "string") {
          flash("error", payload.errors);
        } else {
          let key = Object.keys(payload.errors)[0];
          let message = payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(updateSingleWorkflow.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      });
  },
});

// submit workflow data
export const submitWorkflow = createAsyncThunk(
  "submitWorkflow",
  async (DATA, thunkAPI) => {
    try {
      return await workflowService.submitWorkflow(DATA);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// get all workflows data
export const getAllWorkflow = createAsyncThunk(
  "getAllWorkflow",
  async (DATA, thunkAPI) => {
    try {
      return await workflowService.getAllWorkflow(DATA);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// get single workflow for edit
export const getSingleWorkflow = createAsyncThunk(
  "getSingleWorkflow",
  async (ID, thunkAPI) => {
    try {
      return await workflowService.getSingleWorkflow(ID);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// update single workflow
export const updateSingleWorkflow = createAsyncThunk(
  "updateSingleWorkflow",
  async (DATA, thunkAPI) => {
    try {
      return await workflowService.updateSingleWorkflow(DATA);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const { resetWorkflow, resetWorkflowStatus, resetSingleWorkflow } =
  workflowSlice.actions;
export default workflowSlice.reducer;
